import React from 'react'
import { Drawer } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import ShiftStatusBar from './ShiftStatusBar';
import { formatDateReadable } from '../../utilities/helpers';
import DrawerHeader from '../../shared/helpers/DrawerHeader';
import DrawerFooterContainerSmall from '../../shared/helpers/DrawerFooterContainerSmall';
import ButtonFilled from '../../shared/helpers/ButtonFilled';
import ButtonGrayed from '../../shared/helpers/ButtonGrayed';
import StatusWithText from '../../shared/helpers/StatusWithText';
import ModalUserStatusCard from '../../shared/helpers/ModalUserStatusCard';
import ModalInfoCard from '../../shared/helpers/ModalInfoCard';
import {
  CalendarToday,
  Description,
  ChatBubbleOutline,
  Send,
  Edit,
  AccessTime,
  WorkOutline,
  FreeBreakfastOutlined,
  PlaceOutlined,
  PersonAddAlt
} from '@mui/icons-material';

function PendingTableEmployeeRowShiftPickupDrawer(props) {

  function handlePickupCancel() {
    props.rescind_pickup_shift(props.shiftInfo.id, props.shiftInfo?.store?.id);
    props.onClose();
  }


  return (
    <Drawer anchor="right" open={props.open} onClose={props.onClose}>
      <div className="w-[450px] h-full bg-white relative">
        <div className="max-h-screen overflow-auto">
          <DrawerHeader title="Pickup Request" onClose={props.onClose} />

          <div className="w-full px-6">

            <div className="mb-6">
              <ModalUserStatusCard
                status={props.cardStatus}
                name="Your Pickup Request"
                icon={PersonAddAlt}
                iconColor="text-slate-700"
                backgroundColor="bg-slate-100"
              />
            </div>

            <div className="mb-4 flex items-center space-x-4">
              <div className="flex-1">
                <ModalInfoCard
                  icon={CalendarToday}
                  title="Date"
                  value={formatDateReadable(props.shiftInfo?.date)}
                />
              </div>
              <div className="flex-1">
                <ModalInfoCard
                  icon={AccessTime}
                  title="Time"
                  value={props.shiftInfo?.shift}
                />
              </div>
            </div>

            <div className="mb-4 flex items-center space-x-4">
              <div className="flex-1">
                <ModalInfoCard
                  icon={FreeBreakfastOutlined}
                  title="Break"
                  value={props.shiftInfo?.break_formatted}
                />
              </div>
              <div className="flex-1">
                <ModalInfoCard
                  icon={WorkOutline}
                  title="Role"
                  value={props.shiftInfo?.station
                    ? props.shiftInfo?.station?.name
                    : props.shiftInfo?.role
                    ? props.shiftInfo?.role
                    : props.shiftInfo?.roleType}
                />
              </div>
            </div>

            {props.shiftInfo?.note && (
              <div className="mb-4">
                <ModalInfoCard
                  icon={ChatBubbleOutline}
                  title="Shift Note"
                  value={props.shiftInfo?.note}
                  size="small"
                />
              </div>
            )}

            {props.shiftInfo?.employee_drop_note && (
              <div className="mb-4">
                <ModalInfoCard
                  icon={ChatBubbleOutline}
                  title="Employee Drop Note"
                  value={props.shiftInfo?.employee_drop_note}
                  size="small"
                />
              </div>
            )}

          </div>

          <DrawerFooterContainerSmall>
            <div className="w-full">
              {props.cardStatus === "pending" ? (
                <ButtonFilled text="Cancel Request" onClick={() => handlePickupCancel()} />
              ) : (
                <ButtonGrayed text="Cancel Request" />
              )}
            </div>
          </DrawerFooterContainerSmall>
          <div className="h-[200px]"></div>
        </div>
      </div>
    </Drawer>
  )
}

export default PendingTableEmployeeRowShiftPickupDrawer
